var _style, _path, _g, _g2, _g3, _g4, _g5, _path2, _g6, _g7, _polygon, _rect, _g8, _circle, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _rect2, _g16, _g17, _g18, _g19, _g20, _path3, _g21, _g22, _path4, _g23, _g24, _g25, _g26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIlustraConteudo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480.93 346.72",
    style: {
      enableBackground: "new 0 0 480.93 346.72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BDC0D4;}\n\t.st1{fill:#4D5884;}\n\t.st2{fill:#FF6100;}\n\t.st3{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.52,81.21l-11.24,4.68l12.48,29.99l29.98-12.48l-4.84-11.64c-0.06-0.06-0.11-0.1-0.17-0.15 c-0.01,0-0.01-0.01-0.02-0.02c-0.06-0.04-0.12-0.08-0.18-0.11l-0.01-0.01c-0.11-0.06-0.24-0.11-0.36-0.13 c-0.02-0.01-0.04-0.01-0.06-0.02c-0.04-0.01-0.09-0.01-0.13-0.02c-0.05,0-0.09-0.01-0.14-0.01c-0.04,0-0.08,0-0.11,0 c-0.06,0-0.12,0.01-0.17,0.02c-0.03,0-0.06,0.01-0.09,0.01c-0.09,0.02-0.18,0.04-0.26,0.08c-0.46,0.19-0.78,0.58-0.91,1.03 c-0.41,1.54-1.51,2.87-3.09,3.53c-2.71,1.13-5.83-0.16-6.96-2.87s0.16-5.83,2.87-6.96c1.58-0.66,3.3-0.49,4.68,0.3 c0.41,0.22,0.91,0.28,1.37,0.08c0.09-0.04,0.16-0.08,0.24-0.13c0.03-0.02,0.05-0.04,0.08-0.05c0.05-0.04,0.09-0.07,0.14-0.11 c0.03-0.03,0.05-0.05,0.08-0.08c0.03-0.04,0.06-0.07,0.09-0.11c0.02-0.03,0.05-0.07,0.08-0.1c0.01-0.02,0.02-0.04,0.03-0.06 c0.07-0.11,0.12-0.22,0.16-0.35c0-0.01,0-0.01,0.01-0.02c0.02-0.07,0.03-0.13,0.05-0.2c0-0.01,0-0.02,0-0.03 c0.01-0.07,0.01-0.14,0.02-0.21l-4.85-11.65l-11.24,4.68c-0.76,0.22-1.59-0.15-1.9-0.9c-0.19-0.46-0.14-0.96,0.08-1.37 c0.79-1.38,0.96-3.1,0.3-4.69c-1.13-2.71-4.25-4-6.96-2.87c-2.72,1.13-4,4.25-2.87,6.96c0.66,1.59,2,2.68,3.53,3.09 c0.44,0.13,0.83,0.44,1.03,0.91C147.54,79.98,147.22,80.83,146.52,81.21z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "199.65,28.94 202.95,35.63 210.34,36.71 205,41.92 206.26,49.28 199.65,45.8 193.04,49.28  194.3,41.92 188.96,36.71 196.35,35.63  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.39,52.93l1.77-10.32l-7.5-7.31l10.36-1.51l4.63-9.38l4.63,9.38l10.36,1.51l-7.5,7.31l1.77,10.32 l-9.26-4.87L190.39,52.93z M199.65,43.54l3.95,2.08l-0.75-4.4l3.2-3.12l-4.42-0.64l-1.98-4l-1.98,4l-4.42,0.64l3.2,3.12l-0.75,4.4 L199.65,43.54z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 43.16,
    y: 140.37,
    className: "st1",
    width: 21.85,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51.48,
    y: 132.32,
    className: "st1",
    width: 21.85,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 40.04,
    y: 132.32,
    className: "st1",
    width: 7.28,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31.72,
    y: 140.37,
    className: "st1",
    width: 7.28,
    height: 4
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 392.92,
    y: 114.85,
    className: "st1",
    width: 19.85,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 379.48,
    y: 114.85,
    className: "st1",
    width: 7.28,
    height: 4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 392.92,
    y: 102.47,
    className: "st1",
    width: 19.85,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 379.48,
    y: 102.47,
    className: "st1",
    width: 7.28,
    height: 4
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.7,151.54c0,1.02-0.82,1.84-1.84,1.84h-3.57v6.91l-8.75-6.91h-11.65c-1.02,0-1.84-0.82-1.84-1.84v-16.11 c0-1.02,0.82-1.85,1.84-1.85h23.96c1.02,0,1.84,0.83,1.84,1.85v16.11H147.7z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.13,174.76v-9.04h-1.57c-2.12,0-3.84-1.72-3.84-3.84v-16.11c0-2.12,1.72-3.84,3.84-3.84h23.96 c2.12,0,3.84,1.72,3.84,3.84v16.11c0,2.12-1.72,3.84-3.84,3.84h-10.95L108.13,174.76z M106.71,161.72h5.41v4.78l6.05-4.78h12.18 v-15.79H106.7L106.71,161.72L106.71,161.72z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.79,213.98h-2.31c-0.54,0-1.11-0.41-1.28-0.92l-0.43-1.04c-0.24-0.48-0.12-1.18,0.25-1.56l1.63-1.63 c0.38-0.38,0.38-1,0-1.37l-2.52-2.53c-0.38-0.38-1-0.38-1.38,0l-1.63,1.63c-0.38,0.38-1.08,0.49-1.56,0.26l-1.04-0.43 c-0.51-0.17-0.92-0.75-0.92-1.28v-2.31c0-0.54-0.44-0.98-0.97-0.98h-3.57c-0.54,0-0.98,0.44-0.98,0.98v2.31 c0,0.54-0.41,1.11-0.92,1.28l-1.04,0.43c-0.48,0.24-1.18,0.12-1.56-0.26l-1.63-1.63c-0.38-0.38-1-0.38-1.38,0l-2.52,2.53 c-0.38,0.38-0.38,1,0,1.37l1.63,1.63c0.37,0.38,0.49,1.08,0.25,1.56l-0.43,1.04c-0.17,0.51-0.75,0.92-1.28,0.92h-2.31 c-0.53,0-0.97,0.44-0.97,0.97v3.57c0,0.53,0.44,0.97,0.97,0.97h2.31c0.53,0,1.11,0.41,1.28,0.92l0.43,1.04 c0.24,0.48,0.12,1.18-0.25,1.56l-1.63,1.63c-0.38,0.38-0.38,1,0,1.38l2.52,2.53c0.38,0.38,1,0.38,1.38,0l1.63-1.63 c0.38-0.38,1.08-0.49,1.56-0.25l1.04,0.43c0.51,0.17,0.92,0.75,0.92,1.28v2.31c0,0.54,0.44,0.97,0.98,0.97h3.57 c0.54,0,0.97-0.44,0.97-0.97v-2.31c0-0.54,0.41-1.11,0.92-1.28l1.04-0.43c0.48-0.24,1.18-0.12,1.56,0.25l1.63,1.63 c0.38,0.38,1,0.38,1.38,0l2.52-2.53c0.38-0.38,0.38-1,0-1.38l-1.63-1.63c-0.38-0.38-0.49-1.08-0.25-1.56l0.43-1.04 c0.17-0.51,0.74-0.92,1.28-0.92h2.31c0.54,0,0.97-0.44,0.97-0.97v-3.57C76.76,214.42,76.32,213.98,75.79,213.98z M61.83,221.45 c-2.6,0-4.7-2.11-4.7-4.71s2.11-4.7,4.7-4.7c2.6,0,4.71,2.11,4.71,4.7C66.54,219.34,64.43,221.45,61.83,221.45z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 128.6,
    y: 202.64,
    className: "st1",
    width: 5.77,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 123.63,
    y: 194.7,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -107.0873 207.9461)",
    className: "st1",
    width: 5.77,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 115.15,
    y: 194.16,
    transform: "matrix(0.8661 -0.4998 0.4998 0.8661 -82.806 84.9314)",
    className: "st1",
    width: 4,
    height: 5.77
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 109.9,
    y: 203.32,
    className: "st1",
    width: 5.77,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 114.87,
    y: 211.23,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -125.7869 208.6224)",
    className: "st1",
    width: 5.77,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 125.1,
    y: 210.02,
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -89.4117 92.0483)",
    className: "st1",
    width: 4,
    height: 5.77
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 406.85,
    y: 177.46,
    className: "st1",
    width: 4,
    height: 6.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 399.3,
    y: 181.85,
    transform: "matrix(0.5002 -0.8659 0.8659 0.5002 40.3702 439.9572)",
    className: "st1",
    width: 4,
    height: 6.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 398.14,
    y: 191.73,
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -43.1044 226.5475)",
    className: "st1",
    width: 6.32,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 406.85,
    y: 194.92,
    className: "st1",
    width: 4,
    height: 6.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 414.43,
    y: 190.58,
    transform: "matrix(0.5 -0.866 0.866 0.5 40.427 457.5047)",
    className: "st1",
    width: 4,
    height: 6.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 413.27,
    y: 182.99,
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -36.7125 232.9422)",
    className: "st1",
    width: 6.32,
    height: 4
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "142.06,307.2 132.3,312.84 122.54,318.47 122.54,307.2 122.54,295.93 132.3,301.56 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 95.02,
    y: 279.8,
    className: "st0",
    width: 17.81,
    height: 17.81
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 131.29,
    y: 283.39,
    className: "st1",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.6,287.39h-4.68v-4h4.68V287.39z M117.24,287.39h-4.68v-4h4.68V287.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 103.87,
    y: 283.39,
    className: "st1",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.87,278.71h-4v-4.68h4V278.71z M107.87,269.34h-4v-4.68h4V269.34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 103.87,
    y: 255.98,
    className: "st1",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.6,259.98h-4.68v-4h4.68V259.98z M117.24,259.98h-4.68v-4h4.68V259.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 131.29,
    y: 255.98,
    className: "st1",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.29,278.71h-4v-4.68h4V278.71z M135.29,269.34h-4v-4.68h4V269.34z"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 25.56,
    cy: 42.95,
    r: 3.75
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51.07,
    y: 39.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -12.3475 52.5894)",
    className: "st1",
    width: 12.47,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 55.31,
    y: 34.96,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -12.3428 52.5879)",
    className: "st1",
    width: 4,
    height: 12.47
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 295.74,
    y: 110.35,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 9.0035 246.433)",
    className: "st1",
    width: 12.47,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.97,
    y: 106.13,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 8.9921 246.4385)",
    className: "st1",
    width: 4,
    height: 12.47
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 133.08,
    y: 22.04,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 23.6027 105.0623)",
    className: "st1",
    width: 11.09,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 136.63,
    y: 18.5,
    transform: "matrix(0.7071 -0.7072 0.7072 0.7071 23.6106 105.0764)",
    className: "st1",
    width: 4,
    height: 11.09
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 264.11,
    y: 20.58,
    className: "st1",
    width: 4.06,
    height: 4
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 455.22,
    y1: 138.51,
    x2: 444.72,
    y2: 149.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.54,
    y: 141.76,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 30.1386 360.2825)",
    className: "st1",
    width: 14.85,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 455.22,
    y1: 149.01,
    x2: 444.72,
    y2: 138.51
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.97,
    y: 136.34,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 30.1332 360.285)",
    className: "st1",
    width: 4,
    height: 14.85
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.58,
    y: 335.58,
    className: "st1",
    width: 443.22,
    height: 4
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.76,101.34h23.79c0.17-2.25,0.67-5.18,2.09-7.06c8.78-11.3,9.34-22.07,9.34-22.83 c0-12.87-10.43-23.3-23.3-23.3c-12.87,0-23.3,10.43-23.3,23.3c0,0.76,0.55,11.52,9.33,22.83 C237.12,96.17,237.61,99.09,237.76,101.34z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 239.18,
    y: 75.47,
    transform: "matrix(0.9842 -0.1773 0.1773 0.9842 -11.8667 44.1613)",
    className: "st1",
    width: 4,
    height: 26.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 245.17,
    y: 86.47,
    transform: "matrix(0.1772 -0.9842 0.9842 0.1772 125.3565 326.8857)",
    className: "st1",
    width: 26.02,
    height: 4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "255.79,80.93 253.21,79.48 250.64,80.93 248.68,80.93 246.11,79.48 243.53,80.93 241.57,80.93  238.02,78.93 239.99,75.45 242.55,76.89 245.12,75.44 247.09,75.44 249.66,76.89 252.23,75.44 254.19,75.44 256.77,76.89  259.35,75.44 261.31,78.93 257.75,80.93  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 236.22,
    y: 99.62,
    className: "st1",
    width: 26.91,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 236.22,
    y: 106.7,
    className: "st1",
    width: 26.91,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 240.87,
    y: 113.78,
    className: "st1",
    width: 17.6,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 240.82,
    y: 101.93,
    className: "st1",
    width: 4,
    height: 6.18
  }))))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 178.8,
    y: 141.35,
    className: "st2",
    width: 128.42,
    height: 89.77
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.26,231.29h-4c0-3.91-3.18-7.09-7.09-7.09h-48.49v-90.41h48.49c6.12,0,11.09,4.98,11.09,11.09V231.29z  M189.67,220.2h44.49c2.7,0,5.17,0.97,7.09,2.57v-77.89c0-3.91-3.18-7.09-7.09-7.09h-44.49V220.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.75,231.29h-4v-86.41c0-6.12,4.98-11.09,11.1-11.09h48.49v20.13h-4v-16.13h-44.49 c-3.91,0-7.1,3.18-7.1,7.09v77.89c1.93-1.6,4.4-2.57,7.1-2.57h29.87v4h-29.87C247.94,224.2,244.75,227.38,244.75,231.29z"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 196.92,
    y: 145.77,
    className: "st1",
    width: 21.64,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 196.92,
    y: 159.83,
    className: "st1",
    width: 36.44,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 196.92,
    y: 170.15,
    className: "st1",
    width: 36.44,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 196.92,
    y: 180.48,
    className: "st1",
    width: 26.03,
    height: 4
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 186.31,
    y: 250.92,
    className: "st1",
    width: 80.45,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 186.31,
    y: 259.63,
    className: "st1",
    width: 69.07,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "175.08,261.96 170.36,257.59 173.08,254.66 174.64,256.1 180.14,249.2 183.26,251.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 186.31,
    y: 272.25,
    className: "st1",
    width: 80.45,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 186.31,
    y: 280.96,
    className: "st1",
    width: 69.07,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "175.08,283.29 170.36,278.92 173.08,275.99 174.64,277.43 180.14,270.53 183.26,273.03  "
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "362.34,111.02 346.38,55.9 330.42,111.02 326.58,109.91 346.38,41.51 366.19,109.91  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.38,51.65c-5.49,0-9.95-4.46-9.95-9.95s4.46-9.95,9.95-9.95c5.49,0,9.95,4.46,9.95,9.95 C356.33,47.19,351.87,51.65,346.38,51.65z M346.38,35.75c-3.28,0-5.95,2.67-5.95,5.95c0,3.28,2.67,5.95,5.95,5.95 s5.95-2.67,5.95-5.95C352.33,38.42,349.66,35.75,346.38,35.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 344.38,
    y: 20.65,
    className: "st1",
    width: 4,
    height: 12.16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.38,84.42c-6.63,0-13.25-1.46-19.43-4.37l1.71-3.62c11.26,5.32,24.18,5.32,35.44,0l1.71,3.62 C359.64,82.96,353.01,84.42,346.38,84.42z"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.37,258.43h-4.12l-0.03-2.62v-87.18h0.2c1.07-6.08,6.44-10.76,12.78-10.76h76.68v88.95H298.2 c-4.95,0-8.98,4.03-8.98,8.98c0,0.11,0.01,0.21,0.02,0.32L289.37,258.43z M289.23,171.19v75.26c2.33-2.24,5.5-3.62,8.98-3.62 h72.68v-80.95h-72.68c-4.85,0-8.87,3.95-8.97,8.8L289.23,171.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M374.88,268.79H298.2c-7.16,0-12.98-5.82-12.98-12.98c0-7.16,5.82-12.98,12.98-12.98h76.68V268.79z  M298.21,246.83c-4.95,0-8.98,4.03-8.98,8.98c0,4.95,4.03,8.98,8.98,8.98h72.68v-17.96L298.21,246.83L298.21,246.83z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "319.6,275.6 311.63,270.55 303.67,275.6 303.67,256.76 311.63,256.76 319.6,256.76  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 297.39,
    y1: 256.44,
    x2: 372.89,
    y2: 256.44
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.39,
    y: 254.44,
    className: "st1",
    width: 75.5,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 297.39,
    y1: 244.15,
    x2: 297.39,
    y2: 160.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.39,
    y: 160.94,
    className: "st1",
    width: 4,
    height: 83.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 318.23,
    y: 197.65,
    className: "st1",
    width: 33.76,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 322.19,
    y: 187.02,
    className: "st1",
    width: 25.84,
    height: 4
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M421.22,241.89h4.97v-0.67c0-3.91-3.17-7.08-7.07-7.08h-4.97v0.67C414.15,238.73,417.32,241.89,421.22,241.89z"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M430.74,250.47h-4v-15.36c0-3.14,2.55-5.69,5.69-5.69v4c-0.93,0-1.69,0.76-1.69,1.69V250.47z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M424.18,245.13c6.12,2.53,7.54,2.15,12.72-0.03c12.19-5.34,25.07-1.38,23.26,22.19 c-1.23,11.91-7.33,22.24-21.37,22.27c-2.85,0.01-5.6-0.41-8.15-1.18c-2.54,0.79-5.29,1.22-8.15,1.22 c-14.03,0.03-20.18-10.28-21.46-22.18C399.11,243.86,411.97,239.85,424.18,245.13z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M430.24,240.81v5.97h13.06c3.68,0,6.67-2.99,6.67-6.67v-5.97h-13.06C433.23,234.14,430.24,237.13,430.24,240.81 z"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "120.58,54.23 69.46,54.23 69.46,84.74 77.56,84.74 77.56,94.32 88.15,84.74 120.58,84.74  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 79.45,
    y: 63.84,
    className: "st1",
    width: 31.15,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 79.45,
    y: 71.69,
    className: "st1",
    width: 31.15,
    height: 4
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 285.22,
    y1: 295.99,
    x2: 279.67,
    y2: 290.43
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.43,
    y: 289.31,
    transform: "matrix(0.7072 -0.707 0.707 0.7072 -124.6212 285.5384)",
    className: "st1",
    width: 4,
    height: 7.85
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 283.39,
    y1: 304.61,
    x2: 275.8,
    y2: 306.64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.66,
    y: 303.63,
    transform: "matrix(0.9659 -0.2588 0.2588 0.9659 -69.5728 82.7714)",
    className: "st1",
    width: 7.85,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 289.94,
    y1: 310.51,
    x2: 287.9,
    y2: 318.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 312.31,
    transform: "matrix(0.2593 -0.9658 0.9658 0.2593 -89.5472 511.854)",
    className: "st1",
    width: 7.85,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 298.32,
    y1: 307.78,
    x2: 303.88,
    y2: 313.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.09,
    y: 306.65,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 -131.4224 303.9329)",
    className: "st1",
    width: 4,
    height: 7.86
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 300.16,
    y1: 299.16,
    x2: 307.74,
    y2: 297.13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.01,
    y: 296.14,
    transform: "matrix(0.9659 -0.2588 0.2588 0.9659 -66.8054 88.8176)",
    className: "st1",
    width: 7.85,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 293.6,
    y1: 293.26,
    x2: 295.64,
    y2: 285.68
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.68,
    y: 287.48,
    transform: "matrix(0.2588 -0.9659 0.9659 0.2588 -61.2536 499.1268)",
    className: "st1",
    width: 7.85,
    height: 4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "297.53,307.46 305.33,309.62 313.14,311.79 307.36,317.47 301.58,323.15 299.55,315.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.5,327.01l-5.78-22.4l22.29,6.19L300.5,327.01z M300.33,310.31l2.32,8.98l6.62-6.5L300.33,310.31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 308.59,
    y: 316,
    transform: "matrix(0.7136 -0.7005 0.7005 0.7136 -135.7617 309.4326)",
    className: "st1",
    width: 4,
    height: 9.53
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.48,297.79c-6.89,0-12.5-5.61-12.5-12.5s5.61-12.5,12.5-12.5s12.5,5.61,12.5,12.5 S58.38,297.79,51.48,297.79z M51.48,276.79c-4.69,0-8.5,3.81-8.5,8.5s3.81,8.5,8.5,8.5s8.5-3.81,8.5-8.5S56.17,276.79,51.48,276.79 z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M415.99,58c-3.94,0-7.14-3.2-7.14-7.14s3.2-7.13,7.14-7.13c3.93,0,7.13,3.2,7.13,7.13S419.93,58,415.99,58z  M415.99,47.73c-1.73,0-3.14,1.41-3.14,3.13c0,1.73,1.41,3.14,3.14,3.14s3.13-1.41,3.13-3.14 C419.13,49.13,417.72,47.73,415.99,47.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M444.42,42.74c-3.93,0-7.13-3.2-7.13-7.13s3.2-7.13,7.13-7.13s7.14,3.2,7.14,7.13S448.35,42.74,444.42,42.74 z M444.42,32.47c-1.73,0-3.13,1.41-3.13,3.13s1.41,3.13,3.13,3.13c1.73,0,3.14-1.41,3.14-3.13S446.15,32.47,444.42,32.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M444.42,73.25c-3.93,0-7.13-3.2-7.13-7.14c0-3.93,3.2-7.13,7.13-7.13s7.14,3.2,7.14,7.13 C451.55,70.05,448.35,73.25,444.42,73.25z M444.42,62.98c-1.73,0-3.13,1.41-3.13,3.13c0,1.73,1.41,3.14,3.13,3.14 c1.73,0,3.14-1.41,3.14-3.14C447.55,64.39,446.15,62.98,444.42,62.98z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 428.04,
    y: 47.62,
    transform: "matrix(0.5001 -0.866 0.866 0.5001 164.6341 401.4704)",
    className: "st2",
    width: 4,
    height: 21.05
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 419.5,
    y: 41.59,
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 35.7963 220.8037)",
    className: "st2",
    width: 21.05,
    height: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustraConteudo);
export default __webpack_public_path__ + "static/media/ilustra_conteudo.fb3354b619f88c86a0c44f3b8dcab169.svg";
export { ForwardRef as ReactComponent };